import React, {useEffect, useRef, useState} from "react";
import PropType from 'prop-types';
import styles from 'patterns/ModalDialog/ModalDialog.module.scss'
import {viewportStore} from "stores";
import {Icons} from "utils/Icons";
import F from "utils/F";

export const ModalBody = (props) => {
    return (
        <div className={styles.modalBody}>
            {props.children}
        </div>
    )
}

export const ModalHeader = ({showCloseButton = true, customButton, toggle, title, children}) => {

    const defaultCloseButton = () => {
        return Icons.chevronLeft(styles.closeModal, toggle)
    }

    return (
        <header className={styles.header}>
            {showCloseButton && (customButton ?
                customButton(styles.closeModal, toggle) : defaultCloseButton())}
            <h4 className={styles.modalTitle}>{title}</h4>
            {children}
        </header>
    )
}

ModalHeader.propTypes = {
    showCloseButton: PropType.bool,
    customButton: PropType.func,
    toggle: PropType.func,
    title: PropType.string
}


const ModalDialog = ({isOpen: isOpenProp, className, size, fillMobile = true, blur, children}) => {
    const [isOpen, setIsOpen] = useState(isOpenProp);
    const [visible, setVisible] = useState(isOpenProp);
    const modalBody = useRef();

    useEffect(() => {
        if (isOpenProp && !isOpen) {
            openModal()
        } else if (!isOpenProp) {
            closeModal()
        }
    })

    const width = () => {
        switch (size) {
            case 'sm':
                return {maxWidth: '500px'};
            case 'md':
                return {maxWidth: '700px'};
            case 'lg':
                return {maxWidth: '900px'}
            case 'fullscreen':
                return {width: '100%', height: '100%', maxWidth: '100%', maxHeight: '100%'}
            default:
                return {}
        }
    }

    const openModal = () => {
        setIsOpen(true);
        setVisible(true);
        document.body.style.overflow = 'hidden'
    }

    const closeModal = () => {
        setVisible(false)
        F.sleep(200).then(() => setIsOpen(false))
        document.body.style.overflow = 'unset'
    }

    const renderBuffer = () => {
        return !(size === 'fullscreen' || (viewportStore.isMobile && fillMobile)) &&
            <div style={{minHeight: 0, width: '100%', flex: '1 1 auto'}}/>
    }

    const modalClass = styles.modal + ' ' + (visible ? styles.show : styles.hide) + ' ' + (blur && styles.blur);
    const bodyClass = styles.body + ' ' + className + ' ' + (fillMobile && styles.fillMobile);
    if (!isOpen) {
        return <div/>;
    }
    return (
        <div className={modalClass}>
            {renderBuffer()}
            <div style={width()} ref={modalBody} className={bodyClass}>
                {children}
            </div>
            {renderBuffer()}
        </div>
    )
}

ModalDialog.propTypes = {
    isOpen: PropType.bool.isRequired,
    toggle: PropType.func,
    className: PropType.string,
    size: PropType.oneOf(['sm', 'md', 'lg', 'fullscreen']),
    fillMobile: PropType.bool,
    blur: PropType.bool
}

export default ModalDialog